module.exports = __webpack_public_path__ + "b8125bdf084ca0fb1d332e3809dd0128.svg";